<div class="closing-x-wrap">
    <mat-icon class="close-icon" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<section>
    <h1 mat-dialog-title>Search for a Vehicle <mat-icon class="info-icon" matTooltip="To find a vehicle, enter the VIN, stock ID, or vehicle year, make, model, trim or color, then select the correct vehicle from the results. ">info</mat-icon></h1> 
    <div mat-dialog-content class="content">
        <div class="width-responsive">
            <vehicle-form-component (vehicleSelected$)="selectVehicle($event)"></vehicle-form-component>
        </div>
    </div>
</section>
